import { Button, Card, Tooltip } from "@jhool-io/fe-components";
import { showMoneyInAppFormat } from "../../../../utils/helpers";
import { IBillSummary } from "../../../billing/types/billing.types";
import InfoCircleIcon from "../../../../components/Icons/InfoCircle";

interface PaymentsSummaryProp {
    summaryData: IBillSummary;
}

export default function PaymentsSummary({ summaryData }: PaymentsSummaryProp) {
    return (
        <div className="grid grid-cols-[repeat(auto-fit,minmax(150px,1fr))] gap-12 mb-32 bg-white rounded-r8 px-12 py-16">
            <Card classNames="flex flex-col gap-y-8 px-16 py-12 border border-[#0974461e] bg-blue-100">
                <div className="font-medium uppercase text-xs leading-[1.6rem] text-gray">
                    Total amount due
                </div>
                <div className="font-semibold text-xxl text-primary-800">
                    {showMoneyInAppFormat(summaryData.total_outstanding_amount)}
                </div>
            </Card>
            <Card classNames="flex flex-col gap-y-8 px-16 py-12 border border-[#0974461e] bg-blue-100">
                <div className="flex items-start gap-x-4">
                    <h3 className="font-medium uppercase text-xs leading-[1.6rem] text-gray">
                        Insurance Reimbursement Due
                    </h3>
                    <Tooltip content="Amount sent by the insurance to the patient for the service.">
                        <Button
                            size="auto"
                            variant="normal"
                            aria-label="About insurance reimbursement due"
                        >
                            <InfoCircleIcon stroke="#0B132B" fill="#0B132B" />
                        </Button>
                    </Tooltip>
                </div>
                <div className="font-semibold text-xxl text-primary-800">
                    {showMoneyInAppFormat(summaryData.total_pr100_outstanding)}
                </div>
            </Card>
            <Card classNames="flex flex-col gap-y-8 px-16 py-12 border border-[#0974461e] bg-blue-100">
                <div className="flex items-start gap-x-4">
                    <h3 className="font-medium uppercase text-xs leading-[1.6rem] text-gray">
                        Session Fee Due
                    </h3>
                    <Tooltip content="Amount paid out-of-pocket by the patient.">
                        <Button
                            size="auto"
                            variant="normal"
                            aria-label="About session fee due"
                        >
                            <InfoCircleIcon stroke="#0B132B" fill="#0B132B" />
                        </Button>
                    </Tooltip>
                </div>
                <div className="font-semibold text-xxl text-primary-800">
                    {showMoneyInAppFormat(summaryData.total_coinsurance_amount)}
                </div>
            </Card>
            <Card classNames="flex flex-col gap-y-8 px-16 py-12 border border-[#0974461e] bg-blue-100">
                <div className="flex items-start gap-x-4">
                    <h3 className="font-medium uppercase text-xs leading-[1.6rem] text-gray">
                        Total Unapplied Credit
                    </h3>
                    <Tooltip content="Amount overpaid by the patient.">
                        <Button
                            size="auto"
                            variant="normal"
                            aria-label="About unapplied credit"
                        >
                            <InfoCircleIcon stroke="#0B132B" fill="#0B132B" />
                        </Button>
                    </Tooltip>
                </div>
                <div className="font-semibold text-xxl text-primary-800">
                    {showMoneyInAppFormat(
                        (summaryData.total_coinsurance_credit || 0) +
                            (summaryData.total_pr100_credit || 0)
                    )}
                </div>
            </Card>
        </div>
    );
}
